import { MENU_ITEM } from "../Actions/Utilites";


const INITIAL_STATE = {
  // Add Menu Item
  addMenuItemLoading: false,
  addMenuItemSuccess: false,
  addMenuItemFailure: false,
  addMenuItemError: null,
  addMenuItem: [],

  // Update Menu Item
  updateMenuItemLoading: false,
  updateMenuItemSuccess: false,
  updateMenuItemFailure: false,
  updateMenuItemError: null,
  updateMenuItem: [],

  // Signe Menu Item
  getMenuItemLoading: false,
  getMenuItemSuccess: false,
  getMenuItemFailure: false,
  getMenuItemError: null,
  getMenuItem: [],

  // Delete Menu Item
  deleteMenuItemLoading: false,
  deleteMenuItemSuccess: false,
  deleteMenuItemFailure: false,
  deleteMenuItemError: null,
  deleteMenuItem: [],

  // Add Menu Item
  cloneMenuItemLoading: false,
  cloneMenuItemSuccess: false,
  cloneMenuItemFailure: false,
  cloneMenuItemError: null,
  cloneMenuItem: [],

}

export const MenuItemReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Add Menu Item
    case MENU_ITEM.ADD_MENU_ITEM_REQUEST:
      return {
        ...state,
        addMenuItemLoading: true,
        addMenuItemSuccess: false,
        addMenuItemFailure: false,
        addMenuItemError: null,
      };
    case MENU_ITEM.ADD_MENU_ITEM_SUCCESS:
      return {
        ...state,
        addMenuItemLoading: false,
        addMenuItemSuccess: true,
        addMenuItemFailure: false,
        addMenuItemError: null,
        addMenuItem: [...state.addMenuItem, action.payload.result],
      };
    case MENU_ITEM.ADD_MENU_ITEM_FAILURE:
      return {
        ...state,
        addMenuItemLoading: false,
        addMenuItemSuccess: false,
        addMenuItemFailure: true,
        addMenuItemError: action.payload,
      };

    // Update Menu Item
    case MENU_ITEM.UPDATE_MENU_ITEM_REQUEST:
      return {
        ...state,
        updateMenuItemLoading: true,
        updateMenuItemSuccess: false,
        updateMenuItemFailure: false,
        updateMenuItemError: null,
      };
    case MENU_ITEM.UPDATE_MENU_ITEM_SUCCESS:
      return {
        ...state,
        updateMenuItemLoading: false,
        updateMenuItemSuccess: true,
        updateMenuItemFailure: false,
        updateMenuItemError: null,
        updateMenuItem: action.payload,
      };
    case MENU_ITEM.UPDATE_MENU_ITEM_FAILURE:
      return {
        ...state,
        updateMenuItemLoading: false,
        updateMenuItemSuccess: false,
        updateMenuItemFailure: true,
        updateMenuItemError: action.payload,
      };

    // Sigle Menu Item
    case MENU_ITEM.GET_MENU_ITEM_REQUEST:
      return {
        ...state,
        getMenuItemLoading: true,
        getMenuItemSuccess: false,
        getMenuItemFailure: false,
        getMenuItemError: null,
      };
    case MENU_ITEM.GET_MENU_ITEM_SUCCESS:
      return {
        ...state,
        getMenuItemLoading: false,
        getMenuItemSuccess: true,
        getMenuItemFailure: false,
        getMenuItemError: null,
        getMenuItem: action.payload.result,
      };
    case MENU_ITEM.GET_MENU_ITEM_FAILURE:
      return {
        ...state,
        getMenuItemLoading: false,
        getMenuItemSuccess: false,
        getMenuItemFailure: true,
        getMenuItemError: action.payload,
      };

    // Delete Menu Item
    case MENU_ITEM.DELETE_MENU_ITEM_REQUEST:
      return {
        ...state,
        deleteMenuItemLoading: true,
        deleteMenuItemSuccess: false,
        deleteMenuItemFailure: false,
        deleteMenuItemError: null,
      };
    case MENU_ITEM.DELETE_MENU_ITEM_SUCCESS:
      debugger;
      const result = state.deleteMenuItem.filter(
        (note) => note.id !== action.payload.result
      );
      return {
        ...state,
        deleteMenuItemLoading: false,
        deleteMenuItemSuccess: true,
        deleteMenuItemFailure: false,
        deleteMenuItemError: null,
        deleteMenuItem: result,
      };
    case MENU_ITEM.DELETE_MENU_ITEM_FAILURE:
      return {
        ...state,
        deleteMenuItemLoading: false,
        deleteMenuItemSuccess: false,
        deleteMenuItemFailure: true,
        deleteMenuItemError: action.payload,
      };


    // Clone Menu Item
    case MENU_ITEM.CLONE_MENU_ITEM_REQUEST:
      return {
        ...state,
        cloneMenuItemLoading: true,
        cloneMenuItemSuccess: false,
        cloneMenuItemFailure: false,
        cloneMenuItemError: null,
      };
    case MENU_ITEM.CLONE_MENU_ITEM_SUCCESS:
      return {
        ...state,
        cloneMenuItemLoading: false,
        cloneMenuItemSuccess: true,
        cloneMenuItemFailure: false,
        cloneMenuItemError: null,
        cloneMenuItem: [...state.cloneMenuItem, action.payload.result],
      };
    case MENU_ITEM.CLONE_MENU_ITEM_FAILURE:
      return {
        ...state,
        cloneMenuItemLoading: false,
        cloneMenuItemSuccess: false,
        cloneMenuItemFailure: true,
        cloneMenuItemError: action.payload,
      };
    default:
      return state;
  }
};